import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text, Stack } from '@travel-frontend/core';
import { IconPhone, IconPhoneCallback, IconQuestionAnswer } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Content } from '../../components/ExitIntentLayerPicture/components/Content.js';
import { ContentLayer } from '../../components/ExitIntentLayerPicture/components/ContentLayer.js';
import { CustomPrimaryButton } from '../../components/ExitIntentLayerPicture/components/CustomPrimaryButton.js';
import { CustomSecondaryButton } from '../../components/ExitIntentLayerPicture/components/CustomSecondaryButton.js';
import { SecondaryButtons } from '../../components/ExitIntentLayerPicture/components/SecondaryButtons.js';
import { OPENED_ACTION, openedEvent, CLOSED_ACTION, closedEvent, CALLBACK_BUTTON_CLICKED_ACTION, callbackButtonClickedEvent, CHAT_BUTTON_CLICKED_ACTION, chatButtonClickedEvent, HOTLINE_BUTTON_CLICKED_ACTION, hotlineButtonClickedEvent } from '../../components/ExitIntentLayerPicture/utils/tracking.js';
import { NoWrap } from '../../primitives/index.js';
export const ExitIntentLayerPicture = ({
  open,
  hotline,
  withChatButton = true,
  withHotlineButton = true,
  withCallbackButton = true,
  onClose,
  onClickChatButton,
  onClickHotlineButton,
  onClickCallbackButton
}) => {
  const {
    t
  } = useTranslation('exitLayer');
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch({
      type: CLOSED_ACTION,
      payload: closedEvent()
    });
    onClose();
  };
  const handleChatButtonClick = event => {
    dispatch({
      type: CHAT_BUTTON_CLICKED_ACTION,
      payload: chatButtonClickedEvent()
    });
    onClickChatButton?.(event);
  };
  const handleHotlineButtonClick = event => {
    dispatch({
      type: HOTLINE_BUTTON_CLICKED_ACTION,
      payload: hotlineButtonClickedEvent()
    });
    onClickHotlineButton?.(event);
  };
  const handleCallbackButtonClick = event => {
    dispatch({
      type: CALLBACK_BUTTON_CLICKED_ACTION,
      payload: callbackButtonClickedEvent()
    });
    onClickCallbackButton?.(event);
  };
  useEffect(function handleOpen() {
    if (open) {
      dispatch({
        type: OPENED_ACTION,
        payload: openedEvent()
      });
    }
  }, [open, dispatch]);
  const chatButtonProps = {
    icon: _jsx(IconQuestionAnswer, {}),
    children: t('exitLayerPicture.buttons.chat'),
    onClick: handleChatButtonClick
  };
  const hotlineButtonProps = {
    as: 'a',
    href: `tel:${hotline}`,
    icon: _jsx(IconPhone, {}),
    children: _jsx(NoWrap, {
      children: hotline
    }),
    onClick: handleHotlineButtonClick
  };
  const callbackButtonProps = {
    icon: _jsx(IconPhoneCallback, {}),
    children: t('exitLayerPicture.buttons.callback'),
    onClick: handleCallbackButtonClick
  };
  const primaryButtonProps = withCallbackButton ? callbackButtonProps :
  // eslint-disable-next-line sonarjs/no-nested-conditional
  withChatButton ? chatButtonProps :
  // eslint-disable-next-line sonarjs/no-nested-conditional
  withHotlineButton && hotline ? hotlineButtonProps : null;
  return _jsx(ContentLayer, {
    open: open,
    closeButtonLabel: t('exitLayerPicture.buttons.close'),
    onClose: handleClose,
    children: _jsx(Content, {
      children: _jsxs(Stack, {
        space: "24px",
        children: [_jsxs(Stack, {
          space: "8px",
          children: [_jsx(Text, {
            preset: "headlineLarge",
            align: "center",
            children: t('exitLayerPicture.title')
          }), _jsx(Text, {
            preset: "paragraphMedium",
            align: "center",
            children: t('exitLayerPicture.subtitle')
          })]
        }), _jsxs(Stack, {
          space: "8px",
          children: [primaryButtonProps && _jsx(CustomPrimaryButton, {
            ...primaryButtonProps,
            fullWidth: true
          }), _jsxs(SecondaryButtons, {
            children: [withChatButton && withCallbackButton && _jsx(CustomSecondaryButton, {
              variant: "inverted",
              ...chatButtonProps
            }), withHotlineButton && (withCallbackButton || withChatButton) && _jsx(CustomSecondaryButton, {
              variant: "inverted",
              ...hotlineButtonProps
            })]
          })]
        })]
      })
    })
  });
};